module.exports = __webpack_public_path__ + "img/plan1.fd293399.png";